<script setup lang="ts">
const props = defineProps<{
  variant: SingleProductVariant;
  defaultOpen: boolean;
}>();

const detailsRef = ref<HTMLDetailsElement>();

const { hash } = useRoute();
onMounted(() => {
  // Since the product catalogue is loaded on the client, we need to wait for the component to mount before opening the details
  // FIXME: Load catalogue on the server and do this check directly in the :open attribute
  if (detailsRef.value && hash === `#${props.variant?.isbn}`) {
    detailsRef.value.open = true;
  }
});

const bg = computed(() => props.variant.mainColor || null);
</script>

<template>
  <details
    :id="variant.isbn"
    ref="detailsRef"
    class="variant group mx-auto mb-1 text-black-100 sm:w-full"
    :class="variant.formats"
    :open="defaultOpen"
  >
    <UiSingleProductSummary :variant="variant" />
    <UiSingleProductDetails :variant="variant" />
  </details>
</template>

<style scoped lang="scss">
.variant {
  --bg: v-bind(bg);
  background-color: var(--bg, var(--type-background));

  --outer-padding: 0.75rem;
  padding: var(--outer-padding);

  @media screen and (min-width: $extra-small) {
    --outer-padding: 1.5rem;
    padding-inline: 1.25rem;
  }

  @media screen and (min-width: $small) {
    --outer-padding: 2rem;
    padding-inline: 3.75rem;
  }

  &:has(.preview:hover) {
    transition: all 0.2s ease;
    filter: brightness(90%);
  }

  &.unibok {
    --type-background: theme("colors.seagreen.20");
  }

  &.nettsted {
    --type-background: theme("colors.green.10");
  }

  &.laererprodukt {
    --type-background: theme("colors.seagreen.10");
  }

  &.grunnbok {
    --type-background: rgb(var(--variant-background));
  }

  &.arbeidsbok {
    --type-background: rgb(var(--variant-background), 0.6);
  }

  &.lesebok {
    --type-background: rgb(var(--variant-background), 0.4);
  }
}
</style>
